import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidacyEvaluationNewQueryKey } from "@/hooks/queries/useGetCandidacyEvaluationNew";
import { candidateSheetV2TabCountsQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { CandidacyEvaluationNew, HttpResponse } from "@/types";

export const useCreateAddCandidacyEvaluationNew = () => {
  const companyId = useCurrentCompanyId();
  const jobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      candidacyId,
      evaluation,
    }: {
      candidacyId: string;
      evaluation: CandidacyEvaluationNew;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/candidacies/${candidacyId}/evaluation-new`;
      const response = await guacHttpClient.post<
        CandidacyEvaluationNew,
        HttpResponse<CandidacyEvaluationNew>,
        CandidacyEvaluationNew
      >(path, evaluation);

      return response.data;
    },
    onSuccess: (evaluation, { candidacyId }) => {
      queryClient.setQueryData(
        candidacyEvaluationNewQueryKey(companyId, jobId, candidacyId),
        evaluation,
      );
      void queryClient.invalidateQueries({
        queryKey: candidateSheetV2TabCountsQueryKey,
      });
    },
  });
};
